import script from "./ZCheckboxGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ZCheckboxGroup.vue?vue&type=script&setup=true&lang=js"

import "./ZCheckboxGroup.vue?vue&type=style&index=0&id=72cc55c4&lang=scss"

const __exports__ = script;

export default __exports__